import React from "react";
import { cn } from "@/lib/utils";

/** Responsive table: real table on md+, stacked cards on mobile. */
export const DataTable = ({ columns, rows, onRowClick, rowKey = "id", empty, mobileTitle, className, rowClassName, rowTestId }) => {
  if (!rows?.length) return empty || null;
  return (
    <div className={cn("w-full", className)}>
      <div className="hidden overflow-hidden rounded-xl border border-border bg-card shadow-xs md:block">
        <div className="scroll-slim overflow-x-auto">
          <table className="w-full min-w-[720px] text-sm">
            <thead>
              <tr className="border-b border-border bg-muted/50">
                {columns.map((c) => (
                  <th
                    key={c.key}
                    className={cn(
                      "px-4 py-3 text-left text-xs font-semibold uppercase tracking-wider text-muted-foreground",
                      c.align === "right" && "text-right",
                      c.className
                    )}
                  >
                    {c.label}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {rows.map((r, i) => (
                <tr
                  key={r[rowKey] || i}
                  data-testid={rowTestId?.(r)}
                  onClick={onRowClick ? () => onRowClick(r) : undefined}
                  className={cn(
                    "border-b border-border/70 last:border-0 transition-colors",
                    onRowClick && "cursor-pointer hover:bg-primary-soft/40",
                    rowClassName?.(r)
                  )}
                >
                  {columns.map((c) => (
                    <td key={c.key} className={cn("px-4 py-3 align-middle", c.align === "right" && "text-right", c.cellClassName)}>
                      {c.render ? c.render(r) : r[c.key]}
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      <div className="grid gap-3 md:hidden">
        {rows.map((r, i) => (
          <div
            key={r[rowKey] || i}
            data-testid={rowTestId ? `${rowTestId(r)}-mobile` : undefined}
            onClick={onRowClick ? () => onRowClick(r) : undefined}
            className={cn(
              "flex flex-col gap-2 rounded-xl border border-border bg-card p-4 shadow-xs",
              onRowClick && "cursor-pointer active:scale-[0.995]",
              rowClassName?.(r)
            )}
          >
            {mobileTitle && <div className="mb-1">{mobileTitle(r)}</div>}
            {columns.filter((c) => !c.hideMobile).map((c) => (
              <div key={c.key} className="flex items-start justify-between gap-3 text-sm">
                <span className="text-xs font-medium uppercase tracking-wide text-muted-foreground">{c.label}</span>
                <span className="text-right">{c.render ? c.render(r) : r[c.key]}</span>
              </div>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};
